export default "__VITE_ASSET__BTFPuviN__"